import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import actionReducer from './action';
import comedyReducer from './comedy';
import documentaryReducer from './documentary';
import horrorReducer from './horror';
import flixFrenzyOriginalsReducer from './flixFrenzyOriginals';
import romanceReducer from './romance';
import topRatedReducer from './topRated';
import trendingReducer from './trending';
import latestReducer from './latest';
import nowPlayingReducer from './nowPlaying';
import popularReducer from './popular';
import tvAiringTodayReducer from './tvAiringToday';
import tvLatestReducer from './tvLatest';
import tvOnAirReducer from './tvOnAir';
import tvPopularReducer from './tvPopular';
import tvTopRatedReducer from './tvTopRated';
import upComingReducer from './upcoming';
import userReducer from './user';
import kidsAndFamilyReducer from './kidsAndFamily';
import tvActionAndAdventureReducer from './tvActionAndAdventure';
import tvAnimationReducer from './tvAnimation';
import tvComedyReducer from './tvComedy';
import tvCrimeReducer from './tvCrime';
import tvDocumentaryReducer from './tvDocumentary';
import tvDramaReducer from './tvDrama';
import tvFamilyReducer from './tvFamily';
import tvKidsReducer from './tvKids';
import tvMovieReducer from './tvMovie';
import tvMysteryReducer from './tvMystery';
import tvNewsReducer from './tvNews';
import tvRealityReducer from './tvReality';
import tvSciFiAndFantasyReducer from './tvSciFiAndFantasy';
import tvSoapReducer from './tvSoap';
import tvTalkReducer from './tvTalk';
import tvWarAndPoliticsReducer from './tvWarAndPolitics';
import tvWesternReducer from './tvWestern';
import tvTrendingReducer from './tvTrending';
import adventureReducer from './adventure';
import animationReducer from './animation';
import crimeReducer from './crime';
import dramaReducer from './drama';
import fantasyReducer from './fantasy';
import historyReducer from './history';
import musicReducer from './music';
import mysteryReducer from './mystery';
import scienceFictionReducer from './scienceFiction';
import thrillerReducer from './thriller';
import genresReducer from './genres';
import myListReducer from './myList';
import playMovieReducer from './playMovie';
// eslint-disable-next-line import/no-named-as-default
import showMyListReducer from './showMyList';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const reducers = combineReducers({
  myList: myListReducer,
  action: actionReducer,
  comedy: comedyReducer,
  documentary: documentaryReducer,
  horror: horrorReducer,
  flixFrenzyOriginals: flixFrenzyOriginalsReducer,
  romance: romanceReducer,
  topRated: topRatedReducer,
  trending: trendingReducer,
  latest: latestReducer,
  popular: popularReducer,
  nowPlaying: nowPlayingReducer,
  tvAiringToday: tvAiringTodayReducer,
  tvLatest: tvLatestReducer,
  tvOnAir: tvOnAirReducer,
  tvPopular: tvPopularReducer,
  tvTopRated: tvTopRatedReducer,
  upComing: upComingReducer,
  user: userReducer,
  kidsAndFamily: kidsAndFamilyReducer,
  tvActionAndAdventure: tvActionAndAdventureReducer,
  tvAnimation: tvAnimationReducer,
  tvComedy: tvComedyReducer,
  tvCrime: tvCrimeReducer,
  tvDocumentary: tvDocumentaryReducer,
  tvDrama: tvDramaReducer,
  tvFamily: tvFamilyReducer,
  tvKids: tvKidsReducer,
  tvMovie: tvMovieReducer,
  tvMystery: tvMysteryReducer,
  tvNews: tvNewsReducer,
  tvReality: tvRealityReducer,
  tvSciFiAndFantasy: tvSciFiAndFantasyReducer,
  tvSoap: tvSoapReducer,
  tvTalk: tvTalkReducer,
  tvWarAndPolitics: tvWarAndPoliticsReducer,
  tvWestern: tvWesternReducer,
  tvTrending: tvTrendingReducer,
  adventure: adventureReducer,
  animation: animationReducer,
  crime: crimeReducer,
  drama: dramaReducer,
  fantasy: fantasyReducer,
  history: historyReducer,
  music: musicReducer,
  mystery: mysteryReducer,
  scienceFiction: scienceFictionReducer,
  thriller: thrillerReducer,
  genres: genresReducer,
  playMovie: playMovieReducer,
  showMyList: showMyListReducer,

});

const persistedReducer = persistReducer(persistConfig, reducers);

// This part makes the use of redux-logger only in development
const myMiddlewares = process.env.NODE_ENV === 'development' ? [logger, thunk] : [thunk];

const store = configureStore({
  reducer: persistedReducer,
  middleware: myMiddlewares,
});

export const persistor = persistStore(store);

export default store;
